"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _InputError["default"];
  }
});
var _InputError = _interopRequireDefault(require("./InputError"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }